<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">管理高效化</div>
                     <div class="title-e">MANAGEMENT EFFICIENCY</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe describe1">
                 针对企业充电客户，提供员工车队管理、充电子账户管理、托管充电、无感充电等功能，方便企业客户对本单位车辆实现精细化管理，提高企业充电账户安全和使用效率。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon21"></span> 员工账号资金管控
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon22"></span> 员工分时段充电控制
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon23"></span>
                     远程启动充电功能
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon24"></span>
                     无感充电功能
                 </div>
             </div>

             <div class="data-describe">
                 <div class="data-box data-one">
                     <div class="data-num">即插即充</div>
                     <div class="data-synopsis">
                         <p>支持企业车辆无感充电</p>
                     </div>
                 </div>
                 <div class="data-line"></div>
                 <div class="data-box data-t">
                     <div class="data-num">节降成本</div>
                     <div class="data-synopsis">
                         <p>员工账号分时段充电</p>
                     </div>
                 </div>
             </div>
             <div class="img-describe img2"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./k_public.less" lang="less" scoped></style>


<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fff;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 80%;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            <!--.describe-characteristic{-->
                <!--width: 1000px;-->
                <!--text-align: left;-->
                <!--color: #1A3068;-->
                <!--margin: 14px auto;-->
                <!--font-size: 16px;-->
                <!--line-height: 28px;-->
                <!--.icon-img{-->
                    <!--display: inline-block;-->
                    <!--width: 24px;-->
                    <!--height:24px;-->
                    <!--margin-right: 6px;-->
                    <!--background-repeat: no-repeat;-->
                    <!--background-size: 24px 24px;-->
                    <!--margin-bottom: -6px;-->
                <!--}-->
                <!--.icon1{-->
                    <!--background-image: url('./../../../assets/glgxh1.png');-->
                <!--}-->
                <!--.icon2{-->
                    <!--background-image: url('./../../../assets/glgxh2.png');-->
                <!--}-->
                <!--.icon3{-->
                    <!--background-image: url('./../../../assets/glgxh3.png');-->
                <!--}-->
                <!--.icon4{-->
                    <!--background-image: url('./../../../assets/f.png');-->
                <!--}-->
            <!--}-->
            <!--.data-describe{-->
                <!--width: 1000px;-->
                <!--margin: 30px auto;-->
                <!--display: flex;-->
                <!--.data-box{-->
                    <!--min-width: 170px;-->
                    <!--height:120px;-->
                    <!--padding:10px;-->
                    <!--.data-num{-->
                        <!--color: #19C1E7;-->
                        <!--font-size: 21px;-->
                    <!--}-->
                    <!--.data-synopsis{-->
                        <!--font-size: 12px;-->
                        <!--line-height: 10px;-->
                        <!--font-family:PingFangSC-Regular,PingFang SC;-->
                        <!--font-weight:400;-->
                        <!--color:rgba(26,48,104,1);-->
                    <!--}-->
                <!--}-->
                <!--.data-line{-->
                    <!--min-width: 1px;-->
                    <!--height: 50px;-->
                    <!--background-color: #E6E9F3;-->
                    <!--margin-top: 20px;-->
                <!--}-->

            <!--}-->
            <!--.img-describe{-->
                <!--height: 360px;-->
                <!--width: 376px;-->
                <!--background-image: url('./../../../assets/gxglh.gif');-->
                <!--background-repeat: no-repeat;-->
                <!--background-size: 80%;-->
                <!--position: absolute;-->
                <!--bottom: 100px;-->
                <!--right: 60px;-->
            <!--}-->
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 1100px) {-->
        <!--.img-describe{-->
            <!--background-size: 60%!important;-->
            <!--right: -40px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 1000px) {-->
        <!--.img-describe{-->
            <!--background-size:45%!important;-->
            <!--height: 260px;-->
            <!--width: 264px;-->
            <!--position: absolute;-->
            <!--bottom: 70px!important;-->
            <!--right:-100px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 800px) {-->
        <!--.img-describe{-->
            <!--display: none;-->
        <!--}-->
    <!--}-->








<!--</style>-->